<template>
  <Filtros :filtros="filtrosDefault" />
</template>

<script>
import Filtros from './Index.vue';
export default {
  name: 'FiltrosDefault',
  components: {
    Filtros
  },
  props: {  
    filtros: {
      type: Array,
      required: true
    }
  },
  computed: {
    filtrosDefault() {
      return this.filtros.filter(filtro => filtro.default);
    }
  },
}
</script>